import api from "../utils/api";

export async function getVouchers(params = {}) {
  return (
    await api.get("/api/admin/vouchers", {
      params,
      paramsSerializer: { indexes: null },
    })
  ).data;
}

export async function getVoucher(id) {
  return (await api.get(`/api/admin/vouchers/${id}`)).data;
}

export async function revokeVoucher(id) {
  return (await api.post(`/api/admin/vouchers/${id}/revoke`)).data;
}
